/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const statusEditorSlice = createSlice({
    name: 'statusEditor',
    initialState: initialState,
    reducers: {
        setStatusEditorData: (state, action) => {
            return action.payload;
        },
        addStatusEditor: (state, action) => {
            action.payload.forEach((item) => {
                state.push(item);
            });
        },
        updateStatusEditor: (state, action) => {
            [action.payload].forEach((newItem) => {
                const index = state.findIndex(
                    (item) => item.shipment_type === newItem.shipment_type && item.parent_id === newItem.parent_id
                );
                if (index !== -1) {
                    state[index] = newItem;
                } else {
                    state.push(newItem);
                }
            });
        },
    },
});

export const { setStatusEditorData, addStatusEditor, updateStatusEditor } = statusEditorSlice.actions;
export default statusEditorSlice.reducer;
